<template>
<div class="bg-white px-3 py-3" style="margin: -20px;margin-top: -1rem;margin-bottom: 0!important;">
  <el-form inline ref="form" :model="searchform">

          
          <template v-if="this.userid=='admin'">
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value1" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword1" size="mini" style="width:150px" ></el-input>
          </el-form-item>

          </template>


  
          <el-form-item class="mb-0 mr-0">
             <el-select v-model="searchform.value" :placeholder="$t('searchText.타이틀선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


        
          <el-form-item  class="mb-0 mr-0">
             {{$t('msg.삭제')}}<el-checkbox true-label="1" false-label="0" v-model="searchform.bet_black" style="margin:0 5px;"></el-checkbox>
          </el-form-item>
        
          <el-form-item class="mb-0 mr-0">
            <el-button type="info" size="mini" @click="searchEvent">{{$t('searchText.검색')}}</el-button>
            <el-button type="success" size="mini" @click="editContent(false)">{{$t('tableText.추가')}}</el-button> 
          </el-form-item>
      </el-form>
     

  <el-table
      :data="tableData"
       v-loading="loading"
       style="width: 100%"
       border class="mt-2"
      :empty-text="$t('tableText.데이타가없습니다')">
    
 
 <el-table-column
        
        label="id" prop="id" align="center">
        
      </el-table-column>

        <el-table-column
        :label="$t('tableText.게임아이디')" prop="game_id" align="center">
         
      </el-table-column> 

   

     <el-table-column
        :label="$t('tableText.한글이름')"
         prop="title_ko" align="center">
       

      </el-table-column>
        <el-table-column
        
        :label="$t('tableText.영어타이틀')" prop="title" align="center">
       

      </el-table-column>

         <el-table-column
        :label="$t('tableText.로고')"
        prop="logo" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.logo" width="80" height="80">
        </template>
      </el-table-column>
  

     
       <el-table-column
        :label="$t('tableText.순위')"
        prop="rank" align="center">
      

      </el-table-column>

     
     

     

     <el-table-column
        :label="$t('searchText.구분')"
        prop="type" align="center" width="100">
         <template slot-scope="scope">
              <span>{{iotypeObj[scope.row.type]}}</span>
             
          </template>
      </el-table-column>

         <el-table-column
        :label="$t('searchText.게임수량')"
         prop="cc" align="center">
        
      </el-table-column>

       <el-table-column
         :label="$t('tableText.점검')"
       prop="server_stop" align="center">
        <template slot-scope="scope">
            <el-switch
                                        v-model="scope.row.server_stop" 
                                         active-value="1"
                                         inactive-value="0"
                                        active-color="#13ce66"
                                        inactive-color="#cfcdcd"
                                        @change="gameup(scope)"
                                       >
            </el-switch>
              <!-- <span>{{iotypeObj2[scope.row.server_stop]}}</span> -->
             
          </template>

      </el-table-column>
      
       <el-table-column
       :label="$t('searchText.노출')"
        prop="dis" align="center">
        <template slot-scope="scope">
             <el-switch
                                        v-model="scope.row.dis" 
                                         active-value="1"
                                         inactive-value="0"
                                        active-color="#13ce66"
                                        inactive-color="#cfcdcd"
                                        @change="gameup(scope)"
                                       >
            </el-switch>
              <!-- <span>{{iotypeObj1[scope.row.dis]}}</span> -->
             
          </template>
      </el-table-column> 
      
       <el-table-column :label="$t('status.편집')" align="center" width="200">
         <template slot-scope="scope">
        
           <el-button-group>
             <el-button type="default"  size="mini" @click="gameManger(scope.row.game_id,scope.row.type)">{{$t('nav.게임관리')}}</el-button>
                <el-button type="primary" icon="el-icon-edit" size="mini" @click="editContent(scope)"></el-button>
                <el-button type="danger" icon="el-icon-delete" size="mini" @click="deleteAll(scope)"></el-button>
                
           </el-button-group>
        
      </template>
        </el-table-column>
       <el-table-column :label="$t('newAdd.업데이트')" align="center" width="150">
         <template slot-scope="scope">
        
           
                 <el-button type="primary"  icon="el-icon-refresh" plain size="mini" @click="update(scope)" :loading="scope.row.loadstaus">업데이트</el-button>
          
        
      </template>
        </el-table-column>
      
  
     
    </el-table>
     <div style="height: 100px;"></div>
                      <el-footer class="border-top d-flex align-items-center px-0 position-fixed bg-white" style="bottom: 0;left: 200px;right: 0;z-index: 100;">
          <div style="flex: 1;" class="px-2">
            <el-pagination
            :current-page="currentPage"
            :page-sizes="[5, 10, 15, 20]"
            :page-size="size"
            layout="prev, pager, next"
            :total="total"
            @size-change="handleSizeChange"
                @current-change="handleCurrentChange">
          </el-pagination>
          </div>
        </el-footer>  
       <el-dialog
          :title="$t('status.편집')"
          :visible.sync="creatModel"
          :width="dWidth" :close-on-click-modal ="false">

          <el-form ref="form" :model="form" label-width="100px" v-loading="upLoading" :rules="rules">
             <el-form-item :label="$t('tableText.한글이름')" class="mb-1" prop="title_ko">
              <el-input v-model="form.title_ko"></el-input>
          </el-form-item>
            <el-form-item :label="$t('newAdd.영어이름')" class="mb-1" prop="title">
              <el-input v-model="form.title"></el-input>
          </el-form-item>
          <el-form-item :label="$t('tableText.게임아이디')" class="mb-1" prop="game_id">
              <el-input v-model="form.game_id"></el-input>
          </el-form-item>

        

          <el-form-item :label="$t('tableText.로고')"  class="mb-1" prop="logo">
                <el-avatar :src="form.logo" class="avatar">
              <i class="el-icon-plus avatar-uploader-icon"></i>
            </el-avatar>
             <el-button size="small"  type="primary" plain @click="selectFile()" class="ml-2">{{$t('tableText.이미지수정')}}</el-button> 
            <input type="file"   ref="selectFile" name="wenjian" @change="checkFile($event)"  style="display:none;"/>
          </el-form-item>


           


           <el-form-item :label="$t('tableText.순위')" class="mb-1" prop="rank">
              <el-input v-model="form.rank"></el-input>
          </el-form-item>
           

              <el-form-item :label="$t('searchText.노출')" class="mb-1" prop="dis">
              <el-select v-model="form.dis" :placeholder="$t('searchText.구분')" size="mini" style="width:100px">
               <el-option
                      v-for="item in options"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
              
            </el-form-item>

             <el-form-item :label="$t('tableText.점검')" class="mb-1" prop="server_stop">
               <el-select v-model="form.server_stop" :placeholder="$t('searchText.구분')" size="mini" style="width:100px">
               <el-option
                      v-for="item in options1"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
              
          </el-form-item>

            <el-form-item :label="$t('searchText.구분')" class="mb-1" prop="type">
             <el-select v-model="form.type" :placeholder="$t('searchText.구분')" size="mini" style="width:100px">
               <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>

           <el-form-item :label="$t('searchText.게임수량')" class="mb-1" prop="cc">
              <el-input v-model="form.cc"></el-input>
            </el-form-item>
            
          </el-form>
          <span slot="footer" class="dialog-footer">
             <el-button @click="creatModel = false">{{$t('msg.취소')}}</el-button>
            <el-button type="primary" @click="submit">{{$t('msg.확인')}}</el-button>
          </span>
        
       
       
        </el-dialog>  


      <el-dialog
          :title="$t('nav.게임관리')"
          :visible.sync="creatModel1"
          :width="dWidth1" :close-on-click-modal ="false" class="mydialog-1">
          <div class="mb-1">
            <el-form inline ref="form" :model="searchform">

          
        
          <el-form-item class="mb-0 mr-0">
            <el-button type="danger" size="mini" @click="deleteSd" class="mr-1">{{$t('searchText.선택삭제')}}</el-button>
             <el-select v-model="searchform.value2" :placeholder="$t('status.선택')" size="mini" style="width:120px;">
               <el-option
                      v-for="item in searchform.searchOptions2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
              </el-select>
          </el-form-item>


          <el-form-item class="mb-0 mr-0">
             <el-input :placeholder="$t('searchText.키워드')" v-model="searchform.keyword2" size="mini" style="width:150px" ></el-input>
          </el-form-item>
     <el-form-item class="mb-0 mr-0">

            <el-button type="info" size="mini" @click="searchEvent1">{{$t('searchText.검색')}}</el-button>  
          </el-form-item>
      </el-form>
          </div>
             <el-table
      :data="gamedata"
       v-loading="gameLoading"
       style="width: 100%"
       border class="mt-2"
      :empty-text="$t('tableText.데이타가없습니다')" @selection-change="handleSelectionChange">
      <el-table-column
      type="selection"
      width="55"
      align="center">
    </el-table-column>
 
    <el-table-column
        
        label="ID" prop="id" align="center" width="100">
        
      </el-table-column>
      <el-table-column
        
         :label="$t('newAdd.게임이름')" prop="game_title" align="center">
        
      </el-table-column>
        <el-table-column
        :label="$t('newAdd.이미지')"
        prop="game_image" align="center">
        <template slot-scope="scope">
          <img :src="scope.row.game_image" width="80" height="80">
        </template>
      </el-table-column>
       <el-table-column
        :label="$t('searchText.서비스')"
        prop="is_service" align="center">
        <template slot-scope="scope">
          <el-checkbox true-label="1" false-label="0" v-model="scope.row.is_service" 
          @change="service(scope)"></el-checkbox>
        </template>
      </el-table-column>
    

    </el-table>
  </el-dialog>

    
        
</div>
 </template>

 <script>
  //window.setTimeout('window.location.reload()',30000); //30초마다 새로고침

    export default {
    
      data(){
        return{
          updateLoading:false,
            gameId:'',
            dWidth1:'850px',
            gamedata:[],
            gameLoading:false,
            creatModel1:false,
           iotypeObj:{
              'live':this.$i18n.t("msg.카지노"),
              'slot':this.$i18n.t("msg.슬롯"),
              'slotlive':this.$i18n.t("msg.카지노슬롯"),
             
          
             
            },
             iotypeObj2:{
              '0':this.$i18n.t("msg.정상"),
              '1':this.$i18n.t("tableText.점검"),
             
          
             
            },
            iotypeObj1:{
              '0':this.$i18n.t("msg.숨김"),
              '1':this.$i18n.t("searchText.노출"),
             
          
             
            },
            searchform:{

              searchOptions1:[
             
            
            
            {
              label:this.$i18n.t("msg.알본"),
              value:'admin_id'
            } 
            ],
           
            value1:'',
            keyword1:'',
            searchOptions2:[
             
            
            
            {
              label:this.$i18n.t("newAdd.게임이름"),
              value:'game_title'
            } 
            ],
           
            value2:'',
            keyword2:'',

              bet_black:'',
              searchOptions:[
            {
              label:this.$i18n.t("msg.전체"),
              value:''
            },
            {
              label:this.$i18n.t("msg.슬롯"),
              value:'slot'
            },
            {
              label:this.$i18n.t("msg.카지노"),
              value:'live'
            }
            ],
            value:'',
            keyword:'',
            },
           form:{
            id:'',
              cc:'',
              dis:'',
             
              logo:'',
              game_id:'',
              rank:'',
              server_stop:'',
              title:'',
              title_ko:'',
              title_name:'',
              type:'',



             },
           options:[
                {
                  label:this.$i18n.t("msg.숨김"),
                  value:'0'
                },
                {
                  label:this.$i18n.t("searchText.노출"),
                  value:'1'
                }
              ],
              options1:[
                {
                  label:this.$i18n.t("msg.정상"),
                  value:'0'
                },
                {
                  label:this.$i18n.t("tableText.점검"),
                  value:'1'
                }
              ],
               options2:[
                {
                  label:this.$i18n.t("msg.카지노"),
                  value:'live'
                },
                {
                  label:this.$i18n.t("msg.슬롯"),
                  value:'slot'
                }
              ],
          dWidth:'600px',
        
          domain:window.sessionStorage.getItem('domain'),
          sitetype:window.sessionStorage.getItem('sitetype'),
          bg:window.sessionStorage.getItem('bg'),
          aid:window.sessionStorage.getItem('admin_id'),
          userid:window.sessionStorage.getItem('userid'),
          upLoading:false,
          idDialogVisible: false,
          dialogModel:false,
  
           pickerOptions: {
          },
        shortcuts: [{
            text:this.$i18n.t("dateText.최근한주"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근한달"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit('pick', [start, end]);
            }
          }, {
            text:this.$i18n.t("dateText.최근3개월"),
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit('pick', [start, end]);
            }
          }],
          
    
    
          
            
        
             total:0,
             size:0,
             loading: false,
             editIndex:-1,
             creatModel:false,
             tableData: [],
               currentPage:1,
               multipleSelection:[],
                rules: {

                //  admin_id:[{ required: true, message: '', trigger: 'blur'}],
                  title_ko:[{ required: true, message: '', trigger: 'blur'}],
                  title:[{ required: true, message: '', trigger: 'blur'}],
                  game_id:[{ required: true, message: '', trigger: 'blur'}],
                   logo:[{ required: true, message: '', trigger: 'blur'}],
                  rank:[{ required: true, message: '', trigger: 'blur'}],
                  dis:[{ required: true, message: '', trigger: 'blur'}],
                   server_stop:[{ required: true, message: '', trigger: 'blur'}],
                  type:[{ required: true, message: '', trigger: 'blur'}],
                  cc:[{ required: true, message: '', trigger: 'blur'}],
                },
             
               
       
          }
          
          
        },
        
        created() {
          this.getList()
          
      
    },
      
      methods:{
        handleSelectionChange(val) {
          //console.log(val)
                this.multipleSelection = val;

      },
       service(e){
          
          let token=window.sessionStorage.getItem('user');
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/GameListSS_up',
                      data:{
                          id:e.row.id,
                        is_service:e.row.is_service,
                      
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'success'
                      })
                    
                    }else
                    {
                    
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })
                    }
                    
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

        },
       gameup(e){
              let token=window.sessionStorage.getItem('user');
          
              this.$axios({
                      method:'post',
                      url:this.domain+'/admin/gamess_up',
                      data:{  
                            server_stop:e.row.server_stop,
                            dis:e.row.dis,
                            id:e.row.id,

                           
                      },
                            
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                   if(response.data.code!=200){
                      this.$message.error(response.data.msg)
                    }
                    else{
                      this.$message({
                        message:this.$i18n.t("msg.완료"),
                        type:'success'
                    })    
                    }         
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
        },
         deleteSd(){
        this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
          confirmButtonText: this.$i18n.t("msg.삭제"),
          cancelButtonText: this.$i18n.t("msg.취소"),
          type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');

          //console.log('hh',this.multipleSelection);

                    let newids=[];

           this.multipleSelection.forEach(item=>{
            
            //console.log('id',item.idx);
            newids.push(item.id);
           });

           console.log('newids',newids);

          this.$axios({
                      method:'post',
                       data:{idx:newids,},
                      url:this.domain+'/admin/GameListSS_del',
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else
                    {
                        this.$message({
                         message:response.data.msg,
                          type:'error'
                        })
                    }
                    this.gamesplist()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          })

        
      },  
          gameManger(id,gtype){
          const { href } = this.$router.resolve({
            path: `/gamediaglog/list`,
            query: {
              id: id,
              type: 'SS',
              game_type: gtype,
             
            }
          });
          window.open(href, '_blank','location=no, menubar=no,status=no,resizable=no,titalebar=yes,height=750,width=800');

        },
        searchEvent(){
this.currentPage=1;
          this.getList();
          
             

        },
       searchEvent1(){


          this.gamesplist();
          
             

        },
         gamesplist(){
         this.gameLoading = true
           let token=window.sessionStorage.getItem('user');         
           let urls=this.domain+'/admin/getGameListSS?game_id='+this.gameId+'&'+this.searchform.value2+'='+this.searchform.keyword2;

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 
               if(response.data.code==200){
                  console.log('data=',response.data)
                     let data = response.data
                     this.gamedata =data.data
                     // this.total = data.total
                     // this.currentPage = data.current_page
                     // this.size =data.per_page
                     this.gameLoading =false
               }else
                    {
                     
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })

                       this.gameLoading = false
                     
                    }


                   
               
            }).catch((error) =>{
              
               this.$message.error(error);
              this.gameLoading = false
               
            })
       },
       editContent(e = false){
          let token=window.sessionStorage.getItem('user');
          if(!e){

                    this.form = {

                       id:'',
                        cc:'',
                        dis:'',
                        logo:'',
                        game_id:'',
                        rank:'',
                        server_stop:'',
                        title:'',
                        title_name:'',
                        title_ko:'',
                        type:'',
               }
                this.editIndex = -1
            }else{

              this.editIndex = 1
              this.upLoading = true
               this.$axios({
                  method:'get',
                  url:this.domain+'/admin/GameProviderSS?id='+e.row.id,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
    
            }).then((response) =>{ 
               if(response.data.code==200){
                 this.upLoading = false
                  let item = response.data.data
                  console.log('data==',item)
                  
                    this.form = {

                       id:item.id,
                        cc:item.cc,
                        dis:item.dis,
                        logo:item.logo,
                        game_id:item.game_id,
                        rank:item.rank,
                        server_stop:item.server_stop,
                        title:item.title,
                        title_name:item.title_name,
                         title_ko:item.title_ko,
                        type:item.type,
               }
                 
                         

                }else
                    {
                     
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })

                       this.upLoading = false
                      
                    }

              
               
            }).catch((error) =>{
                console.log(error)       //请求失败返回的数据
                this.upLoading = false
            })

            }

          this.creatModel = true
         
        },
            
           selectFile () {
                 
             
              this.$refs.selectFile.click()  // 这样就会触发 文件的选择
          },
          checkFile(e) {

          console.log(e);
        
          let token=window.sessionStorage.getItem('user');
          let file = e.target.files[0]
          const formData = new FormData()
          formData.append('file', file)
          this.$axios({
　　　　　　　　　　url: this.domain+'/admin/fileu',
　　　　　　　　　　method: 'post',
                  'Accept': 'application/json',
                  headers: { 'Authorization': 'Bearer ' + token },
　　　　　　　　　　data: formData,
　　　　　　　　　
　　　　　　　　}).then((url) => {
                    this.$message.success(this.$i18n.t("msg.업로드완료"))
                    console.log('url:',url.data.data)
                    this.form.logo= url.data.data
                     
                            　　　　　　　　　　
　　　　　　　　　
　　　　　　　　}).catch(err => {
          console.error(err)
        })

    
    },
         deleteAll(e){
          this.$confirm(this.$i18n.t("msg.삭제하시겠습니까"), this.$i18n.t("msg.알림"), {
           confirmButtonText: this.$i18n.t("msg.삭제"),
           cancelButtonText: this.$i18n.t("msg.취소"),
           type: 'warning'
        }).then(() => {
          let token=window.sessionStorage.getItem('user');
   

          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/GameProviderSS_del?id='+e.row.id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     this.loading = false
                    
                    this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                  
       

          }).catch(() => {
          this.$message({
            type: 'info',
            message:this.$i18n.t("msg.취소됨")
          });          
        });

        
      },  
      update(e){
           let token=window.sessionStorage.getItem('user');
           e.row.loadstaus = true
 
          this.$axios({
                      method:'post',
                      url:this.domain+'/admin/update_game_ss?game_id='+e.row.game_id,
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                    
                    if(response.data.code==200){
                      this.$message({
                      message:response.data.msg,
                      type:'success'
                    })
                    }else{
                      this.$message({
                      message:response.data.msg,
                      type:'error'
                    })
                    }

                     e.row.loadstaus = false
                    
                    // this.getList()
    
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })

        
      },  
       submit(){
              let token=window.sessionStorage.getItem('user');
              this.$refs.form.validate((e)=>{
                 if(!e) return;
                  if (this.editIndex === -1) {
                    this.upLoading =true
               this.$axios({
                        method:'post',
                        url:this.domain+'/admin/GameProviderSS_insert',
                        data:{
                           id:this.form.id,
                         admin_id:this.searchform.keyword1,
                          cc:this.form.cc,
                          dis:this.form.dis,
                          logo:this.form.logo,
                          game_id:this.form.game_id,
                          rank:this.form.rank,
                          server_stop:this.form.server_stop,
                          title:this.form.title,
                          title_ko:this.form.title_ko,
                          title_name:this.form.title_name,
                          type:this.form.type
                        },
                        'Accept': 'application/json',
                         headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 
                         if(response.data.code !=200)
                            {
                               this.$message.error({
                            message:response.data.msg,
                            type: 'warning'
                          });


                                
                            }else{
                               this.$message.success(this.$i18n.t("msg.완료"));
                               //console.log(this.form);
                               this.getList();
                               //this.tableData.unshift(this.form)
                               //关闭
                     this.creatModel = false

                            }
                           this.upLoading =false
                     
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                }else{
                  this.$axios({
                      method:'post',
                      url:this.domain+'/admin/GameProviderSS_up',
                      data:{
                         
                         id:this.form.id,
                         admin_id:this.searchform.keyword1,
                          cc:this.form.cc,
                          dis:this.form.dis,
                          logo:this.form.logo,
                          game_id:this.form.game_id,
                          rank:this.form.rank,
                          server_stop:this.form.server_stop,
                          title:this.form.title,
                          title_ko:this.form.title_ko,
                          title_name:this.form.title_name,
                          type:this.form.type
                         
                        },   
                      'Accept': 'application/json',
                      headers: { 'Authorization': 'Bearer ' + token },
                      
                     
                  }).then((response) =>{ 

                   if(response.data.code==200){
                       this.creatModel = false
                       this.$message({
                          message:this.$i18n.t("msg.수정완료"),
                          type:'success'
                      })   
                    }else
                    {
                       this.creatModel = false
                       this.$message({
                          message:response.data.msg,
                          type:'error'
                      })   
                    }
                    this.getList()
                   
                  }).catch((error) =>{
                      console.log(error)       //请求失败返回的数据
                  })
                }
              })
              

   
        },
         handleSizeChange(val) {
              //console.log(`每页 ${val} 条`);
              this.size = val
              this.getList();
              this.loading= true

            },
            handleCurrentChange(val) {
              //console.log(`当前页: ${val}`);
              this.currentPage = val
              this.getList();
              this.loading= true
            },
           
        getList(){

   
          this.loading = true

           let token=window.sessionStorage.getItem('user');
            //console.log(token);
           let urls=this.domain+'/admin/getGameProviderSS?del='+this.searchform.bet_black+'&type='+this.searchform.value+'&admin_id='+this.searchform.keyword1;

          this.$axios({
                  method:'get',
                  url:urls,
                  'Accept': 'application/json',
                   headers: { 'Authorization': 'Bearer ' + token },
                
               
            }).then((response) =>{ 
               if(response.data.code==200){
                  console.log('data=',response.data)
                     let data = response.data
                     this.tableData =data.data
                     // this.total = data.total
                     // this.currentPage = data.current_page
                     // this.size =data.per_page
                     this.loading =false
               }else
                    {
                     
                       this.$message({
                          message:response.data.msg,
                          type:'warning'
                      })

                       this.loading = false
                     
                    }


                   
               
            }).catch((error) =>{
              
               this.$message.error(error);
              this.loading = false
               
            })
        },
        
          getVal(e){

          if(this.form.money=='')
          {
            this.form.money='0';
          }

          if(e=='0')
          {
            this.form.money='0';
          }

          this.form.money=parseInt(this.form.money)+parseInt(e)
          console.log(e)
        },
        
      
        
      }
  }
</script>

 <style scoped>
 .bg-danger{
  background-color:#72e8ff!important
 }
.bg-primary{
  background-color:#9dcdff!important
}
.bg-yellow {
    background-color: #f3ff77!important;
}
/deep/ .el-select-dropdown__item.selected{
  color:#000
}
/deep/ .el-input__inner{
  background:transparent;
  border:1px solid #cfcfcf;
  border-radius:2px;
}
/deep/ .el-dialog__body{
  padding:10px 20px;
}
/deep/ .el-form-item {
  margin-bottom:10px;
}

/deep/ .el-form-item__content{
    display:flex;
    align-items:center;
    line-height:30px;
 }
 
 /deep/ .el-input__inner{
  height:30px;
  line-height:30px;
 }
 /deep/ .el-form-item__label{
  line-height:30px;
 }
 /deep/ .el-dialog__body{
  padding:10px 20px
 }
 /deep/.typeIco .el-input__icon{
  line-height: 30px;
 }
</style>


// WEBPACK FOOTER //
// src/views/gamess/list.vue